import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { reducer as toast } from '@tock/toast';
import app from './app';
import availability from './availability';
import business from './business';
import calendar from './calendar';
import checkout from './checkout';
import consumerPage from './consumerPage';
import delivery from './delivery';
import discover from './discover';
import experiments from './experiments';
import features from './features';
import giftCard from './giftCard';
import history from './history';
import lastGuest from './lastGuest';
import lock from './lock';
import loyaltyProgram from './loyaltyProgram';
import metroArea from './metroArea';
import navigation from './navigation';
import packageState from './package';
import partnerRole from './partnerRole';
import pastPurchase from './pastPurchase';
import patron from './patron';
import paymentCard from './paymentCard';
import playlist from './playlist';
import purchase from './purchase';
import queryParam from './queryParam';
import reschedule from './reschedule';
import scrollDetector from './scrollDetector';
import search from './search';
import selection from './selection';
import supplementGroups from './supplementGroups';
import syndicate from './syndicate';
import theme from './theme';
import tockGiftCard from './tockGiftCard';
import transfer from './transfer';
import ui from './ui';
import walkinWaitlist from './walkinWaitlist';
import widgetBuilder from './widgetBuilder';

import AppConstants from 'constants/AppConstants';
import cookieConsent from 'state/cookieConsent';

export const reducers = {
  app,
  availability,
  business,
  calendar,
  checkout,
  cookieConsent,
  consumerPage,
  delivery,
  discover,
  experiments,
  features,
  giftCard,
  history,
  lastGuest,
  lock,
  loyaltyProgram,
  metroArea,
  navigation,
  packageState,
  partnerRole,
  pastPurchase,
  patron,
  paymentCard,
  playlist,
  purchase,
  queryParam,
  reschedule,
  scrollDetector,
  search,
  selection,
  supplementGroups,
  syndicate,
  theme,
  tockGiftCard,
  toast,
  transfer,
  ui,
  walkinWaitlist,
  widgetBuilder,
};

export default combineReducers({
  ...reducers,
  form: formReducer.plugin({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ChangeEmailForm: (state: never, action: any) => {
      switch (action.type) {
        case AppConstants.PATRON_INITIATE_EMAIL_CHANGE_DONE:
          // Clear out the change email form on success.
          return void 0;
        default:
          return state;
      }
    },
  }),
});
